export default {"src":"/_next/static/media/SMG.80ac2c38.svg","height":18,"width":18};